import { createRouter, createWebHistory } from 'vue-router'
import BodyView from '../layout/BodyView.vue'
import auth from "../auth/authView.vue"
import login from "../auth/loginPage.vue"
import errorPage1 from '../errors/errorPage1.vue';
import errorPage2 from '../errors/errorPage2.vue';
import errorPage3 from '../errors/errorPage3.vue';
import errorPage4 from '../errors/errorPage4.vue';

// dashboard
import IndexDefault from '../components/dashboard/default/IndexDefault.vue'

// order
import indexOrder from "../components/orders/order/indexOrder"
import indexAdd from "../components/orders/addOrder/indexAdd"
import orderDetails from "../components/orders/orderDetails/orderDetails"
import scanOrder from "../components/orders/scanOrder/scanOrder"

// parcel
import parcelList from "../components/parcel/indexList"
// manifest
import manifestList from "../components/manifest/indexList"
// service_prices
import servicePricesList from "../components/service_prices/indexList"
// balance_histories
import balanceHistoriesList from "../components/balance_histories/indexList"
// payments
import paymentsList from "../components/payments/indexList"
// bank accounts
import bankAccountsList from "../components/bankAccounts/indexList.vue"

// customer rank
import customerRankList from "../components/customerRank/indexList"
// service
import serviceList from "../components/service/indexList"
// customer
import customerList from "../components/customer/indexList"
// user
import userList from "../components/user/indexList"
import roleList from "../components/role/indexList"


// users (profile/cards)
import userProfile from "../components/users/profile/userProfile"
import editProfile from "../components/users/editProfile/editProfile"
import cardIndex from "../components/users/userCards/cardIndex"

// basic auth pages if they exist
import ragister_simple from "../components/authentication/ragister_simple"
import login_simple from "../components/authentication/login_simple.vue"

const routes = [
  {
    path: "",
    redirect: "/dashboard/default",
  },
  {
    path: '/dashboard',
    component: BodyView,
    children: [
      {
        path: 'default',
        name: 'defaultIndex',
        component: IndexDefault,
        meta: { title: 'Dashboard | Vioshipping' }
      }
    ]
  },
  {
    path: '/',
    component: BodyView,
    children: [
      {
        path: 'orders/indexOrder',
        name: 'indexOrder',
        component: indexOrder,
        meta: { title: 'Order List' }
      },
      {
        path: 'orders/add',
        name: 'indexAdd',
        component: indexAdd,
        meta: { title: 'Add Order' }
      },
      {
        path: 'orders/orderDetails/:id',
        name: 'orderDetails',
        component: orderDetails,
        meta: { title: 'Order Details' }
      },
      {
        path: 'orders/scan',
        name: 'scanOrder',
        component: scanOrder,
        meta: { title: 'Scan Order' }
      },

      {
        path: 'parcel/list',
        name: 'parcelList',
        component: parcelList,
        meta: { title: 'Parcel List' }
      },
      {
        path: 'manifest/list',
        name: 'manifestList',
        component: manifestList,
        meta: { title: 'Manifest List' }
      },
      {
        path: 'service-prices/list',
        name: 'servicePricesList',
        component: servicePricesList,
        meta: { title: 'Service Prices List' }
      },
      {
        path: 'balance-histories/list',
        name: 'balanceHistoriesList',
        component: balanceHistoriesList,
        meta: { title: 'Balance Histories List' }
      },
      {
        path: 'payments/list',
        name: 'paymentsList',
        component: paymentsList,
        meta: { title: 'Payments List' }
      },
      {
        path: 'bank-accounts/list',
        name: 'bankAccountsList',
        component: bankAccountsList,
        meta: { title: 'Bank Accounts List' }
      },
      {
        path: 'user/list',
        name: 'userList',
        component: userList,
        meta: { title: 'Users List' }
      },
      {
        path: 'role/list',
        name: 'roleList',
        component: roleList,
        meta: { title: 'Roles & Permissions' }
      },

      {
        path: 'customer/list',
        name: 'customerList',
        component: customerList,
        meta: { title: 'Customer List' }
      },
      {
        path: 'customer-rank/list',
        name: 'customerRankList',
        component: customerRankList,
        meta: { title: 'Customer Rank List' }
      },
      {
        path: 'service/list',
        name: 'serviceList',
        component: serviceList,
        meta: { title: 'Service List' }
      },
      {
        path: 'users/profile',
        name: 'userProfile',
        component: userProfile,
        meta: { title: 'User Profile' }
      },
      {
        path: 'users/edit',
        name: 'editProfile',
        component: editProfile,
        meta: { title: 'Edit Profile' }
      },
      {
        path: 'users/cards',
        name: 'cardIndex',
        component: cardIndex,
        meta: { title: 'User Cards' }
      }
    ]
  },
  {
    path: '/orders/print/:ids',
    name: 'printOrder',
    component: () => import('../components/orders/printOrder/indexPrint.vue'),
    meta: { title: 'Print Labels' }
  },
  {
    path: "/auth",

    component: auth,
    children: [
      {
        path: "login",
        name: "login",
        component: login,
        meta: { title: 'Login' }
      },
      {
        path: "register",
        name: "ragister_simple",
        component: ragister_simple,
        meta: { title: 'Register' }
      }
    ]
  },
  {
    path: "/authentication/login/simple",
    name: "login-simple",
    component: login_simple,
    meta: { title: 'Login Simple' }
  },
  {
    path: '/error-400',
    name: 'Error400',
    component: errorPage1,
  },
  {
    path: '/error-401',
    name: 'Error401',
    component: errorPage2,
  },
  {
    path: '/error-403',
    name: 'Error403',
    component: errorPage3,
  },
  {
    path: '/error-404',
    name: 'Error404',
    component: errorPage4,
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  linkExactActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }

  const publicPages = ['/auth/login', '/auth/register', '/authentication/login/simple'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  const userRole = localStorage.getItem('user_role');

  if (authRequired && !loggedIn) {
    return next('/auth/login');
  }

  // Role-based protection mapping
  if (loggedIn && userRole) {
    const roleName = userRole.toLowerCase();
    const roleRestrictions = {
      customer: [
        '/user/list',
        '/customer/list',
        '/customer-rank/list',
        '/service/list',
        '/manifest/list',
        '/parcel/list',
        '/service-prices/list',
        '/balance-histories/list',
        '/role/list',
        '/bank-accounts/list'
      ],

      operation: [
        '/user/list',
        '/balance-histories/list',
        '/role/list',
        '/bank-accounts/list'
      ],

      sale: [
        '/user/list',
        '/manifest/list',
        '/parcel/list',
        '/service-prices/list',
        '/balance-histories/list',
        '/role/list',
        '/bank-accounts/list'
      ],

      accountant: [
        '/user/list',
        '/customer/list',
        '/customer-rank/list',
        '/service/list',
        '/manifest/list',
        '/parcel/list',
        '/service-prices/list',
        '/role/list',
        '/bank-accounts/list'
      ],

      staff: [
        '/user/list',
        '/customer/list',
        '/customer-rank/list',
        '/service/list',
        '/manifest/list',
        '/parcel/list',
        '/service-prices/list',
        '/payments/list',
        '/balance-histories/list',
        '/role/list',
        '/bank-accounts/list'
      ]

    };

    const restricted = roleRestrictions[roleName];
    if (restricted && restricted.some(path => to.path.startsWith(path))) {
      return next('/dashboard/default');
    }
  }

  next();
});

export default router
